import { useMemo } from 'react';

import { QRCodeCanvas } from 'qrcode.react';

import { Box, CommitSha, Divider, ElvaLogoNameWhite, Heading2, Inline, Spinner, Stack, Text, u } from '@ui';

import { QR_KEY, QR_URL } from '../../consts';
import { useBoothQRCode } from '../../hooks';

import * as css from './FloorLoginScreen.css';

export const FloorLoginScreen = () => {
    const { data: code } = useBoothQRCode();

    const encodedURL = useMemo(() => {
        if (!code?.qrCode) return null;
        const baseURL = new URL(QR_URL);
        baseURL.searchParams.set(QR_KEY, code?.qrCode);
        return baseURL.toString();
    }, [code?.qrCode]);

    return (
        <div className={css.container}>
            <span
                style={{
                    color: 'white',
                    position: 'absolute',
                    top: 10,
                    fontWeight: 'bold',
                }}
            >
                <ElvaLogoNameWhite />
            </span>
            <div>
                <Inline
                    style={{
                        backgroundColor: '#0E0E0E',
                        padding: '20px 40px',
                    }}
                    alignItems="center"
                    gap={u(5)}
                >
                    <Box p={u(2)}>
                        {encodedURL ? (
                            <QRCodeCanvas size={180} value={encodedURL} />
                        ) : (
                            <Box
                                style={{ width: 180, height: 180 }}
                                display={'flex'}
                                alignItems={'center'}
                                justifyContent={'center'}
                            >
                                <Spinner size="l" />
                            </Box>
                        )}
                    </Box>
                    <Divider orientation="vertical" length={80} color={'#313131'} />
                    <Stack>
                        <Heading2>SCAN TO CONTINUE</Heading2>
                        <Text>For more information, see the control device nearby</Text>
                        <CommitSha />
                    </Stack>
                </Inline>
            </div>
        </div>
    );
};
